import environment from "./BaseEnvironment";

/*
 * environments for test
 * You shouldn't have override anything.
 */

const baseUrl = "https://test.frontend.upquai.com/";      // URL to run the application (HOST & PORT)
const baseApi = "https://test.webservice.upquai.com/api"; // Test API
// const baseUrl = "http://localhost:4200/api"; // URL of Localhost
// const baseApi = "http://localhost:8000/api"; // URL of Local server
const APP_ENVIRONMENT = "testing"
const enableItemClassification = false;



const env = environment(baseApi);

const TestEnvironment = {
  ...env,
  baseUrl: baseUrl,
  baseApi: baseApi,
  APP_ENVIRONMENT : APP_ENVIRONMENT,
  enableItemClassification: enableItemClassification

};

export default TestEnvironment;
